// import React from 'react';

// const TotalQuotesCard = () => (
//   <div className="bg-custom-gradient text-white p-4 rounded shadow-lg flex items-center">
//     <div className="bg-white px-4 py-2 rounded mr-4">
//       <img src="/images/qoute.png" className='w-[30px] h-[35px]' alt="Quote Icon" />
//     </div>
//     <div>
//       <h2 className="text-[20px] text-[#BDCFE3] font-medium">Total Quotes</h2>
//       <p className="text-md font-semibold">$1,658</p>
//     </div>
//   </div>
// );

// const ModulesCard = () => (
//   <div className="bg-custom-gradient text-white p-4 rounded shadow-lg flex items-center">
//     <div className="bg-white px-4 py-2 rounded mr-4">
//       <img src="/images/module.png" className='w-[30px] h-[35px]' alt="Module Icon" />
//     </div>
//     <div>
//       <h2 className="text-[20px] text-[#BDCFE3] font-medium">Modules</h2>
//       <p className="text-md font-semibold">$10</p>
//     </div>
//   </div>
// );

// const PremiumCard = () => (
//   <div className="bg-custom-gradient text-white p-4 rounded shadow-lg flex items-center">
//     <div className="bg-white px-5 py-3 rounded mr-4">
//       <img src="/images/dollor.png" className='w-[20px] h-[30px]' alt="Dollar Icon" />
//     </div>
//     <div>
//       <h2 className="text-[20px] text-[#BDCFE3] font-medium">Premium</h2>
//       <p className="text-md font-semibold">$6,374</p>
//     </div>
//   </div>
// );

// const DashboardCards = () => {
//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ">
//       <TotalQuotesCard />
//       <ModulesCard />
//       <PremiumCard />

//       {/* <span className="underline underline-offset-[5px]">Test Offset</span> */}
//     </div>
//   );
// };

// export default DashboardCards;


import React, { useState, useEffect } from "react";
import ApiService from "../services/ApiService";

const Card = ({ imgSrc, title, value }) => (
  <div className="bg-custom-gradient text-white p-6 rounded-lg shadow-lg flex items-center w-auto max-w-[400px]">
    <div className="bg-white p-3 rounded-lg flex justify-center items-center w-14 h-14">
      <img src={imgSrc} className="w-[30px] h-[35px]" alt={`${title} Icon`} />
    </div>
    <div className="ml-4">
      <h2 className="text-[18px] sm:text-[20px] text-[#BDCFE3] font-medium">{title}</h2>
      <p className="text-lg font-semibold">{value}</p>
    </div>
  </div>
);

const DashboardCards = () => {

  const [metrics, setMetrics] = useState({ quotes: 0, modules: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const response = await ApiService.getAdminMetrcis();
        // Assuming the API returns an object like: { status: "success", data: { quotes, modules } }
        if (response.status === "success") {
          setMetrics(response.data);
        } else {
          setError("Failed to fetch metrics.");
        }
      } catch (err) {
        console.error("Error fetching metrics:", err);
        setError("Error fetching metrics.");
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);
 
  if (loading) {
    return <div>Loading metrics...</div>;
  }

  // if (error) {
  //   return <div className="text-red-500">{error}</div>;
  // }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <Card
        imgSrc="/images/qoute.png"
        title="Total Quotes"
        value={metrics.quotes}
      />
      <Card
        imgSrc="/images/module.png"
        title="Modules"
        value={metrics.modules}
      />
      {/* You can add more cards here as needed */}
    </div>
  );
};

export default DashboardCards;
